/**
 * DetailTab — 右侧内容区子标签按钮（共享组件）
 *
 * 金色下划线风格 Tab，用于 ClientDetail / ProjectDetail 右侧 Tab 栏。
 */
export default function DetailTab({ active, onClick, label }) {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 text-sm font-semibold transition-all relative"
      style={{
        color: active ? '#1a1a2e' : '#9ca3af',
        borderBottom: active ? '2px solid #c9a84c' : '2px solid transparent',
        background: 'none',
        cursor: 'pointer',
      }}
    >
      {label}
    </button>
  );
}
